import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AugmentedPlayerComponent } from './augmented-player.component';

@NgModule({
    declarations: [AugmentedPlayerComponent],
    imports: [
        CommonModule
    ],
    exports: [AugmentedPlayerComponent]
})
export class AugmentedPlayerModule { }
